// Calm progress line shown in the reader's own language while a translation is prepared.
const LINES = {
  en: "Translating… this can take up to a minute.",
  hi: "अनुवाद हो रहा है… इसमें एक मिनट तक लग सकता है।",
  mr: "भाषांतर सुरू आहे… याला एक मिनिटापर्यंत वेळ लागू शकतो.",
  gu: "અનુવાદ થઈ રહ્યો છે… આમાં એક મિનિટ સુધીનો સમય લાગી શકે છે.",
  kn: "ಅನುವಾದಿಸಲಾಗುತ್ತಿದೆ… ಇದಕ್ಕೆ ಒಂದು ನಿಮಿಷದವರೆಗೆ ಸಮಯ ಬೇಕಾಗಬಹುದು.",
  ta: "மொழிபெயர்க்கப்படுகிறது… இதற்கு ஒரு நிமிடம் வரை ஆகலாம்.",
  te: "అనువదిస్తోంది… దీనికి ఒక నిమిషం వరకు పట్టవచ్చు.",
  ml: "വിവർത്തനം ചെയ്യുന്നു… ഇതിന് ഒരു മിനിറ്റ് വരെ എടുത്തേക്കാം.",
  bn: "অনুবাদ করা হচ্ছে… এতে এক মিনিট পর্যন্ত সময় লাগতে পারে।",
  pa: "ਅਨੁਵਾਦ ਹੋ ਰਿਹਾ ਹੈ… ਇਸ ਵਿੱਚ ਇੱਕ ਮਿੰਟ ਤੱਕ ਲੱਗ ਸਕਦਾ ਹੈ।",
};

export const translatingLine = (lang) => LINES[(lang || "en").toLowerCase()] || LINES.en;
